import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/http/base-http.service';
import { Config } from '@shared/configs/config';
import { AttachmentPacket } from '../models/attachment-packet.model';
import { AttachmentService } from '@shared/services/attachment.service';
import { HttpEventType } from '@angular/common/http';

@Injectable()
export class AttachmentsManageService extends BaseHttpService {
  attachmentPacket: AttachmentPacket = null;

  constructor(public attachmentService: AttachmentService) {
    super();
    this.setInitialAttachmentPacket();
  }

  setInitialAttachmentPacket() {
    this.attachmentPacket = new AttachmentPacket();
  }

  createAttachmentPacket(
    attachments?: any[],
    config?: any
  ): Observable<{ progress: number; result?: AttachmentPacket }> {
    let str = Object.entries(config || {})
      .map(([key, val]) => `${key}=${val}`)
      .join('&');

    const url = `${Config.API}/attachment-packet${str?.length ? '?' + str : ''}`;
    return this.post(url, { attachments }, false, true, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map((event) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = Math.round((event.loaded / (event.total ?? 1)) * 100);
            return { progress };

          case HttpEventType.Response:
            const attachmentPacket = new AttachmentPacket(event.body);
            this.attachmentPacket = attachmentPacket;
            return { progress: 100, result: attachmentPacket };

          default:
            return { progress: 0 };
        }
      })
    );
  }

  updateAttachmentPacket(id: number, attachments: any[], config?: any): Observable<any> {
    let str = Object.entries(config || {})
      .map(([key, val]) => `${key}=${val}`)
      .join('&');

    const url = `${Config.API}/attachment-packet/${id}${str?.length ? '?' + str : ''}`;
    return this.post(url, { attachments }, false, true, {
      reportProgress: true,
      observe: 'events'
    }).pipe(
      map((event) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = Math.round((event.loaded / (event.total ?? 1)) * 100);
            return { progress };

          case HttpEventType.Response:
            const attachmentPacket = new AttachmentPacket(event.body);
            this.attachmentPacket = attachmentPacket;
            return { progress: 100, result: attachmentPacket };

          default:
            return { progress: 0 };
        }
      })
    );
  }

  createAttachmentPacketFromSources(projectId: number | null, sourceAttachmentIds: number[]): Observable<{ progress: number; result?: AttachmentPacket }> {
    return this.postAttachmentPacketSources(`${Config.API}/attachment-packet`, projectId, sourceAttachmentIds);
  }

  updateAttachmentPacketFromSources(
    id: number,
    projectId: number | null,
    sourceAttachmentIds: number[]
  ): Observable<{ progress: number; result?: AttachmentPacket }> {
    return this.postAttachmentPacketSources(`${Config.API}/attachment-packet/${id}`, projectId, sourceAttachmentIds);
  }

  deleteAttachmentPacket(id: number): Observable<object> {
    const url = `${Config.API}/attachment-packet/${id}`;
    return this.delete(url);
  }

  private postAttachmentPacketSources(
    url: string,
    projectId: number | null,
    sourceAttachmentIds: number[]
  ): Observable<{ progress: number; result?: AttachmentPacket }> {
    const formData = new FormData();
    if (projectId) formData.append('projectId', String(projectId));
    sourceAttachmentIds.forEach((id) => formData.append('sourceAttachmentIds[]', String(id)));

    return this.post(url, formData, false, false, { reportProgress: true, observe: 'events' }).pipe(
      map((event) => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            return { progress: Math.round((event.loaded / (event.total ?? 1)) * 100) };
          case HttpEventType.Response:
            this.attachmentPacket = new AttachmentPacket(event.body);
            return { progress: 100, result: this.attachmentPacket };
          default:
            return { progress: 0 };
        }
      })
    );
  }
}
